module.exports = __webpack_public_path__ + "static/media/ad_somersby.b803dc9a.png";